import React from "react"
import CalculatorWrapperStyle from "./CalculatorWrapperStyle.module.css"
import translate, { keys } from "../../../../../translation/translator"

const CalculatorWrapper = ({ children, locale }) => {
  return (
    <div id="calculator" className={CalculatorWrapperStyle.wrapper}>
      <h2 className={CalculatorWrapperStyle.calculator_wrapper_title}>
        {translate(keys.CALORIE_CALCULATOR_DESCRIPTION, locale)}
      </h2>
      {children}
    </div>
  )
}

export default CalculatorWrapper
